
<!--<div class="content">
  <app-todo (loadingEvent)="onLoadingEvent($event)"></app-todo>
  @if (showLoading) {
  <mat-spinner></mat-spinner>
}
</div> -->

<div class="home">
    <section class="sidebar">
      <app-toolbar></app-toolbar>
    </section>
  
    <div class="content">
        <main @enterTransition>
            <router-outlet></router-outlet>
        </main>
    </div>
  </div>
  

